import Controller from "./editableDocuments.controller";
import template from "./editableDocuments.html";

const editableDocuments = {
  template,
  controller: Controller,
  bindings: {
    files: "=",
    expanded: "<",
    validation: "<",
    collapsible: "<",
    title: "@",
    type: "@",
    allowMultiple: "<",
    resource: "@",
    resourceMethod: "@",
    resourceRemoveMethod: "@",
    resourceId: "@",
    documentKey: "@",
    uploadMsg: "@",
    uploadDoneEventName: "<",
    addFileEventName: "<",
    isDisabled: "<",
    isRequired: "<",
    maxSize: "<",
    sizeUnit: "<",
  },
};

export default editableDocuments;



// WEBPACK FOOTER //
// ./src/components/editableDocuments/editableDocuments.component.js